{
  "name": "awp-frontend-webapp",
  "//version": "Displayed in the UI (see support-information.service.ts). On release, the CI pipeline overwrites this with the pushed git tag (x.y.z.w) before building. This committed value is only the local/dev fallback and is NOT updated by releases. See README 'Release'.",
  "version": "0.0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "start npm run api && ng serve -o",
    "build": "ng build",
    "build-DEV_TEST": "ng build --configuration=DEV_TEST",
    "build-INT": "ng build --configuration=INT",
    "build-QA": "ng build --configuration=QA",
    "build-QA_US": "ng build --configuration=QA_US",
    "build-QA_CN": "ng build --configuration=QA_CN",
    "build-PROD": "ng build --configuration=production",
    "build-PROD_US": "ng build --configuration=PROD_US",
    "build-PROD_CN": "ng build --configuration=PROD_CN",
    "test": "ng test --watch=false",
    "lint": "ng lint",
    "api": "node dev-api/json-api.js",
    "translation": "node copyEnUsTranslationsToOtherTranslationFiles.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.25",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.25",
    "@angular/compiler": "21.2.25",
    "@angular/core": "21.2.25",
    "@angular/forms": "21.2.25",
    "@angular/platform-browser": "21.2.25",
    "@angular/platform-browser-dynamic": "21.2.25",
    "@angular/router": "21.2.25",
    "@bmw-ds/components": "11.6.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@service-and-repairs/awpintegrationlib": "28.4.0-0",
    "@service-and-repairs/calm-leads-customer-lib-api": "6.18.0",
    "@service-and-repairs/dms-api": "23.9.0",
    "@service-and-repairs/dms-common": "23.9.0",
    "@service-and-repairs/dms-impl": "23.9.0",
    "ag-grid-angular": "^33.3.2",
    "ag-grid-community": "^33.3.2",
    "jwt-decode": "~4.0.0",
    "p-queue": "6.6.2",
    "rxjs": "7.8.2",
    "tslib": "^2.6.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.27",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/cli": "21.2.27",
    "@angular/compiler-cli": "21.2.25",
    "@types/jasmine": "^6.0.0",
    "@typescript-eslint/eslint-plugin": "^8.59.2",
    "@typescript-eslint/parser": "^8.59.2",
    "baseline-browser-mapping": "^2.11.21",
    "eslint": "^9.39.4",
    "jasmine-core": "6.2.0",
    "json-server": "^0.17.4",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-junit-reporter": "^2.0.1",
    "typescript": "^5.9.3"
  },
  "overrides": {
    "xmlbuilder2": {
      "js-yaml": "^3.15.2"
    },
    "@eslint/eslintrc": {
      "js-yaml": "^4.3.2"
    },
    "cosmiconfig": {
      "js-yaml": "^4.3.2"
    },
    "qs": "^6.16.0",
    "uuid": "^11.1.1"
  }
}
